import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { connectModal as reduxModal } from 'redux-modal';
import { submit } from 'redux-form';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import Button from 'ui/common/button';
import SubmitButton from 'ui/common/form/submit-button';

import { selectIsDeletingUpdateEducation } from 'store/features/education/selectors';
import { updateEducationEntry, deleteEducationEntry } from 'store/features/education/actions';
import { selectEducationEntryById } from 'store/features/education/selectors';
import createForm from 'ui/education/form';
import DeleteEducationEntryConfirmationModal from 'ui/education/delete/confirmation-dialog';

const { request: updateEducationEntryRequest } = updateEducationEntry;
const { request: deleteEducationEntryRequest } = deleteEducationEntry;

const messages = defineMessages({
  title: {
    id: 'update-education-entry-dialog.title',
    defaultMessage: 'Update Education',
  },
  save: {
    id: 'update-education-entry-dialog.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'update-education-entry-dialog.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'update-education-entry-dialog.delete',
    defaultMessage: 'Delete',
  },
});

export const MODAL_NAME = id => `update-education-entry-${id}`;
const FORM_NAME = id => `update-education-entry-form-${id}`;

class UpdateEducationEntry extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  onSubmit(values) {
    const { id } = this.props;
    const { currentlyStudying } = values;
    if (currentlyStudying) values.endDate = null;
    this.props.updateEducationEntryRequest(values, FORM_NAME(id), MODAL_NAME(id));
  }

  delete() {
    const { id } = this.props;
    this.props.deleteEducationEntryRequest({ id }, MODAL_NAME(id));
  }

  getForm() {
    const { id, entry } = this.props;

    const Form = createForm({
      form: FORM_NAME(id),
      initialValues: entry,
      onSubmit: this.onSubmit,
    });

    return <Form />;
  }

  render() {
    const { id, show, intl: { formatMessage }, handleHide, isDeletingUpdateEducation } = this.props;

    const form = this.getForm();

    return (
      <Modal isOpen={show} size="lg">
        <ModalHeader toggle={handleHide}>{formatMessage(messages.title)}</ModalHeader>
        <ModalBody>{form}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.delete} loading={isDeletingUpdateEducation}>
            {formatMessage(messages.delete)}
          </Button>
          <SubmitButton size="md" formName={FORM_NAME(id)} explicitlyTriggerSubmit>
            {formatMessage(messages.save)}
          </SubmitButton>
          <DeleteEducationEntryConfirmationModal id={id} />
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { id } = ownProps;

  return {
    id,
    entry: id ? selectEducationEntryById(state, { id }) : undefined,
    isDeletingUpdateEducation: selectIsDeletingUpdateEducation(state),
  };
}

const mapDispatchToProps = {
  submit,
  updateEducationEntryRequest,
  deleteEducationEntryRequest,
};

const ConnectedUpdateEducationEntry = connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(UpdateEducationEntry)
);

export default function({ id }) {
  const name = MODAL_NAME(id);
  const WrappedModal = reduxModal({
    name,
  })(ConnectedUpdateEducationEntry);
  return <WrappedModal id={id} />;
}
